import React from 'react';
import { Box } from '@mui/material';
import AgentCard from './AgentCard';
import { AgentMarketPlaceItemWithFilter } from '../../pages/userAgent/agentMarketPlace/AgentMarketPlace';

interface AgentCardsListProps {
  agents: AgentMarketPlaceItemWithFilter[];
  onEdit: (agent: AgentMarketPlaceItemWithFilter) => void;
  onDelete: (agentId: string, agentName?: string) => Promise<void>;
}

const AgentCardsList: React.FC<AgentCardsListProps> = ({ agents, onEdit, onDelete }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        justifyContent: 'center',
      }}
    >
      {agents.map((agent) => (
        <AgentCard key={agent._id} agent={agent} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </Box>
  );
};
export default AgentCardsList;
